import Vue from 'vue'
import Router from 'vue-router'
const AppLogin = () => import('@/views/authentication/AppLogin')
const AppLogout = () => import('@/views/authentication/AppLogout')
const AppAdminListOriginsRecipients = () =>
  import('@/views/admin/AppAdminListOriginsRecipients')
const AppAdminListNatures = () => import('@/views/admin/AppAdminListNatures')
const AppAdminOrigin = () => import('@/views/admin/AppAdminOrigin')
const AppAdminRecipient = () => import('@/views/admin/AppAdminRecipient')
const AppAdminNatureForm = () => import('@/views/admin/AppAdminNatureForm')
const AppAdminUsers = () => import('@/views/admin/AppAdminUsers')
const AppAdminUserForm = () => import('@/views/admin/AppAdminUserForm')
const AppAdminListLogs = () => import('@/views/admin/AppAdminListLogs')
const AppAdminConfig = () => import('@/views/admin/AppAdminConfig')
const NotFound = () => import('@/views/NotFound')

const MapView = () => import('@/views/MapView')
const GridView = () => import('@/views/GridView')
const EventView = () => import('@/views/EventView')
const ActionView = () => import('@/views/ActionView')
const InformationView = () => import('@/views/InformationView')

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      redirect: '/plan'
    },
    {
      path: '/plan',
      name: 'map',
      component: MapView
    },
    {
      path: '/grille',
      name: 'grid',
      component: GridView
    },
    {
      path: '/event/:mode/:eventId(\\d+)?',
      name: 'event',
      component: EventView,
      beforeEnter: function (to, from, next) {
        if (isReader() && to.params.mode !== 'detail') {
          if (to.params.mode === 'create') {
            return next({ name: 'login' })
          } else {
            next({
              name: 'event',
              params: { mode: 'detail', eventId: to.params.eventId }
            })
          }
        }
        if (['create', 'edit', 'detail'].indexOf(to.params.mode) > -1) {
          next()
        } else {
          next(false)
        }
      }
    },
    {
      path: '/event/:eventId(\\d+)/children/create',
      name: 'createChildren',
      component: EventView,
      meta: {
        requiresAuth: false
      },
      beforeEnter: function (to, from, next) {
        if (isReader()) {
          return next({ name: 'login' })
        } else {
          next()
        }
      }
    },
    {
      path: '/event/:eventId(\\d+)/action/create',
      name: 'createAction',
      component: ActionView,
      meta: {
        requiresAuth: false
      },
      beforeEnter: function (to, from, next) {
        if (isReader()) {
          return next({ name: 'login' })
        } else {
          next()
        }
      }
    },
    {
      path: '/event/:eventId(\\d+)/action/:mode/:actionId(\\d+)?',
      name: 'action',
      component: ActionView,
      beforeEnter: function (to, from, next) {
        if (isReader() && to.params.mode !== 'detail') {
          if (to.params.mode === 'create') {
            return next({ name: 'login' })
          } else {
            next({
              name: 'action',
              params: {
                mode: 'detail',
                eventId: to.params.eventId,
                actionId: to.params.actionId
              }
            })
          }
        }

        if (['create', 'edit', 'detail'].indexOf(to.params.mode) > -1) {
          next()
        } else {
          next(false)
        }
      }
    },
    {
      path: '/evenement/:eventId(\\d+)/information/:mode/:informationId(\\d+)?',
      name: 'information',
      component: InformationView,
      beforeEnter: function (to, from, next) {
        if (isReader() && to.params.mode !== 'detail') {
          if (to.params.mode === 'create') {
            return next({ name: 'login' })
          } else {
            next({
              name: 'information',
              params: {
                mode: 'detail',
                eventId: to.params.eventId,
                informationId: to.params.informationId
              }
            })
          }
        }

        if (['create', 'edit', 'detail'].indexOf(to.params.mode) > -1) {
          next()
        } else {
          next(false)
        }
      }
    },
    {
      path: '/login',
      name: 'login',
      component: AppLogin,
      meta: {
        requiresAuth: false,
        layout: 'Authentication'
      },
      beforeEnter: function (to, from, next) {
        /*
         * Prevent the user from login in twice
         * same account logged in multiple times can cause auth tokens collision
         */
        const loggedIn =
          window.localStorage.getItem('auth') &&
          window.localStorage.getItem('oauth-credentials')
        if (loggedIn) {
          next('/')
        } else {
          next()
        }
      }
    },
    {
      path: '/logout',
      name: 'logout',
      component: AppLogout,
      meta: {
        layout: 'Authentication'
      }
    },
    {
      path: '/admin',
      name: 'admin',
      component: AppAdminUsers,
      meta: {
        layout: 'Admin',
        requiredAdmin: true
      }
    },
    {
      path: '/admin/users',
      name: 'users',
      component: AppAdminUsers,
      meta: {
        layout: 'Admin',
        requiredAdmin: true
      }
    },
    {
      path: '/admin/natures',
      name: 'natures',
      component: AppAdminListNatures,
      meta: {
        layout: 'Admin',
        requiredAdmin: true
      }
    },
    {
      path: '/admin/origins',
      name: 'origins',
      component: AppAdminListOriginsRecipients,
      meta: {
        layout: 'Admin',
        requiredAdmin: true
      }
    },
    {
      path: '/admin/origins/create',
      name: 'createOrigin',
      component: AppAdminOrigin,
      meta: {
        layout: 'Admin',
        requiredAdmin: true,
        type: 'origin'
      }
    },
    {
      path: '/admin/origins/edit/:id',
      name: 'updateOrigin',
      component: AppAdminOrigin,
      meta: {
        layout: 'Admin',
        requiredAdmin: true,
        type: 'origin'
      }
    },
    {
      path: '/admin/recipients/create',
      name: 'createRecipient',
      component: AppAdminRecipient,
      meta: {
        layout: 'Admin',
        requiredAdmin: true,
        type: 'recipient'
      }
    },
    {
      path: '/admin/recipients/edit/:id',
      name: 'updateRecipient',
      component: AppAdminRecipient,
      meta: {
        layout: 'Admin',
        requiredAdmin: true,
        type: 'recipient'
      }
    },
    {
      path: '/admin/nature-information/create',
      name: 'createNatureInformation',
      component: AppAdminNatureForm,
      meta: {
        layout: 'Admin',
        requiredAdmin: true,
        type: 'information',
        mode: 'create',
        origin: 'natures'
      }
    },
    {
      path: '/admin/nature-information/edit/:id',
      name: 'updateNatureInformation',
      component: AppAdminNatureForm,
      meta: {
        layout: 'Admin',
        requiredAdmin: true,
        type: 'information',
        mode: 'update',
        origin: 'natures'
      }
    },
    {
      path: '/admin/nature-action/create',
      name: 'createNatureAction',
      component: AppAdminNatureForm,
      meta: {
        layout: 'Admin',
        requiredAdmin: true,
        type: 'action',
        mode: 'create',
        origin: 'natures'
      }
    },
    {
      path: '/admin/nature-action/edit/:id',
      name: 'updateNatureAction',
      component: AppAdminNatureForm,
      meta: {
        layout: 'Admin',
        requiredAdmin: true,
        type: 'action',
        mode: 'update',
        origin: 'natures'
      }
    },
    {
      path: '/admin/nature-event/create',
      name: 'createNatureEvent',
      component: AppAdminNatureForm,
      meta: {
        layout: 'Admin',
        requiredAdmin: true,
        type: 'event',
        mode: 'create',
        origin: 'natures'
      }
    },
    {
      path: '/admin/nature-event/edit/:id',
      name: 'updateNatureEvent',
      component: AppAdminNatureForm,
      meta: {
        layout: 'Admin',
        requiredAdmin: true,
        type: 'event',
        mode: 'update',
        origin: 'natures'
      }
    },
    {
      path: '/admin/users/create',
      name: 'userCreate',
      component: AppAdminUserForm,
      meta: {
        layout: 'Admin',
        requiredAdmin: true,
        mode: 'create'
      }
    },
    {
      path: '/admin/users/edit/:id',
      name: 'userUpdate',
      component: AppAdminUserForm,
      meta: {
        layout: 'Admin',
        requiredAdmin: true,
        mode: 'update'
      }
    },
    {
      path: '/admin/exports',
      name: 'logs',
      component: AppAdminListLogs,
      meta: {
        layout: 'Admin',
        requiredAdmin: true
      }
    },
    {
      path: '/admin/configuration',
      name: 'config',
      component: AppAdminConfig,
      meta: {
        layout: 'Admin',
        requiredAdmin: true
      }
    },
    {
      path: '*',
      name: '404',
      component: NotFound
    }
  ]
})

const isReader = () => {
  const auth = JSON.parse(window.localStorage.getItem('auth'))
  return (
    auth && auth.user.roles.findIndex((role) => role === 'ROLE_READER') > -1
  )
}

const isAdmin = () => {
  const auth = JSON.parse(window.localStorage.getItem('auth'))
  return auth && auth.user.roles.findIndex((role) => role === 'ROLE_ADMIN') > -1
}

router.beforeEach((to, from, next) => {
  const loggedIn =
    window.localStorage.getItem('oauth-credentials') &&
    window.localStorage.getItem('auth')

  if (to.meta.requiresAuth !== false && !loggedIn) {
    return next('/login')
  }
  if (to.params.block) {
    return next(false)
  }

  if (to.meta.requiredAdmin) {
    if (isAdmin()) {
      return next()
    }

    return !loggedIn ? next('/login') : next('/plan')
  }
  next()
})

export default router
